import { Component, signal, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Theme, ThemeService } from '@doddly/core';
import { IconComponent } from '../icon/icon.component';

const DARK_THEME_ICON_NAME = 'dark';
const LIGHT_THEME_ICON_NAME = 'light';

/**
 * Light/Dark theme picker
 */
@Component({
  selector: 'ly-theme-picker',
  standalone: true,
  imports: [CommonModule, ButtonModule, IconComponent],
  templateUrl: './theme-picker.component.html',
})
export class ThemePickerComponent {
  // Track current theme from the service
  currentTheme = signal<Theme>(Theme.System);

  constructor(private themeService: ThemeService) {
    // Subscribe to theme changes
    effect(
      () => {
        const theme = this.themeService.currentTheme();
        this.currentTheme.set(theme);
      },
      { allowSignalWrites: true },
    );
  }

  get isLightTheme(): boolean {
    return this.currentTheme() === Theme.Light;
  }

  get iconName(): string {
    return this.isLightTheme ? LIGHT_THEME_ICON_NAME : DARK_THEME_ICON_NAME;
  }

  async toggleTheme() {
    await this.themeService.toggleLightAndDarkTheme();
  }
}
